import {Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
	constructor() {
		this.header = document.querySelector(".header-main");
		if (this.header) {
			this.navMain = this.header.querySelector(".navs");
			this.headerClass = this.header.className.replace("is-on-top", "");
            this.toggleMobileNav();
            this.toggleHeader();
            GlobalVariables.resizeCallbacks.push(this);
		}
	}

    toggleMobileNav() {
        this.navToggle = document.querySelector(".nav-main-toggle");
        this.navMainEl = document.querySelector("#nav-main");
        this.focusTrapTargets = [
            document.querySelector("#main-content"),
            document.querySelector("footer"),
            document.querySelector(".nav-search"),
            document.querySelector(".nav-appearance"),
        ].filter(Boolean);

        if (this.navToggle) {
            this.navToggle.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeMobileNav();
                } else {
                    this.openMobileNav();
                }
            });
        }

        // RGAA 10.8 : le menu off-canvas fermé est masqué visuellement mais reste
        // dans l'arbre d'accessibilité. On l'ignore des AT tant qu'il est fermé sur mobile.
        this.syncNavMainInert();
    }

    isMobileNav() {
        return window.innerWidth <= 991;
    }

    syncNavMainInert() {
        if (!this.navMainEl) return;
        const shouldBeInert = this.isMobileNav() && !document.body.classList.contains("navs-open");
        this.navMainEl.toggleAttribute("inert", shouldBeInert);
    }

    openMobileNav() {
        document.body.classList.add("navs-open");
        GlobalVariables.lenis?.stop();
        this.navMainEl?.removeAttribute("inert");
        this.focusTrapTargets.forEach(el => el.setAttribute("inert", ""));
        if (this.navToggle) {
            this.navToggle.setAttribute("aria-expanded", "true");
            this.navToggle.setAttribute("aria-label", this.navToggle.dataset.labelClose ?? "Fermer le menu de navigation");
        }
        const firstLink = document.querySelector("#nav-main a");
        if (firstLink) firstLink.focus();
    }

    closeMobileNav() {
        document.body.classList.remove("navs-open");
        GlobalVariables.lenis?.start();
        this.focusTrapTargets.forEach(el => el.removeAttribute("inert"));
        this.syncNavMainInert();
        if (this.navToggle) {
            this.navToggle.setAttribute("aria-expanded", "false");
            this.navToggle.setAttribute("aria-label", this.navToggle.dataset.labelOpen ?? "Ouvrir le menu de navigation");
            this.navToggle.focus();
        }
    }

	toggleHeader() {
		Observer.create({
			type: "scroll",
			tolerance: 60,
			dragMinimum: 30,
			onStop: () => {
				if (window.scrollY < 100) {
					this.header.className = this.headerClass;
					this.header.classList.add("is-on-top");
				} else {
					this.header.classList.remove("is-on-top");
				}
			},
			onStopDelay: 0,
			onUp: () => {
				this.showHeader();
			},
			onDown: () => {
				this.hideHeader();
			},
		});

		if (window.innerWidth > 991) {
			setTimeout(() => {
				if (window.scrollY > 100) {
					this.hideHeader();
				}
			}, 0);
		}
	}

	hideHeader() {
		this.header.className = this.headerClass + " hide ";
	}

	showHeader() {
		this.header.classList.remove("hide");

	}

	resize() {
        if (window.innerWidth > 991) {
            this.closeMobileNav();
        }
        this.syncNavMainInert();
	}
}
